var styles = {"caption":"styles_caption__23ULI p2 flex","curation-icon":"styles_curation-icon__3NuRf mr1","curationIcon":"styles_curation-icon__3NuRf mr1","category-icon":"styles_category-icon__1Imx5","categoryIcon":"styles_category-icon__1Imx5","break":"styles_break__2rGWm mb2"};

export default styles;
//# sourceMappingURL=styles.css.js.map
